import React from 'react';
import PropTypes from 'prop-types';

import { useNavigate } from 'react-router-dom';
import { I18n } from '@aws-amplify/core';

import { ButtonGhostIcon, IconArrowLeft16 } from 'pac-ux-components';

export const BackButton = ({ cancelUrl, label }) => {
    const navigate = useNavigate();

    return (
        <React.Fragment>
            {cancelUrl ? (
                <ButtonGhostIcon
                    type="button"
                    icon={<IconArrowLeft16 />}
                    onClick={(event) => {
                        event.preventDefault();
                        navigate(cancelUrl);
                    }}
                    tabIndex={3}
                >
                    {label}
                </ButtonGhostIcon>
            ) : null}
        </React.Fragment>
    );
};

BackButton.propTypes = {
    cancelUrl: PropTypes.string,
    label: PropTypes.string,
};

BackButton.defaultProps = {
    label: I18n.get('Back'),
};
